<script>
// Components
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import UserProfile from "@/router/views/users/user-profile"

// Service
import UsersDataService from "@/services/UsersDataService"
import MarketingDataService from "@/services/MarketingDataService";

// Helper
import UserUtils from '@/helpers/users'
import DateUtils from '@/helpers/date';
import Storage from '@/helpers/storage'

// External Components
import DatePicker  from "vue2-datepicker";
import 'vue2-datepicker/index.css';
import {VueTabs, VTab} from 'vue-nav-tabs'
import 'vue-nav-tabs/themes/vue-tabs.css';
import CoolLightBox from 'vue-cool-lightbox'
import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css'

import isEmpty from 'is-empty';


export default {
  page: {
    localePicker: () => import(`vue2-datepicker/locale/${this.$i18n.locale}`),
    title: "App Uninstalls",
    meta: [
      {
        name: "description",
        content: appConfig.description
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    DatePicker,
    VueTabs,
    VTab,
    UserProfile,
    CoolLightBox,
  },
  methods: {
    ...UserUtils,
    ...DateUtils,

    _isEmpty(val) {
      return isEmpty(val);
    },

    getMediaThumb() {
      if (!isEmpty(this.uninstalls)) {
        this.uninstalls.forEach(uninstall => {
          if (!isEmpty(uninstall.photo))
            Storage.getUserMedia(uninstall.userId, uninstall.photo, 'appUninstall-user-' + uninstall.appUninstallId);
        });
      }
    },

    getRequestParams(page, pageSize) {
      let params = {};

      if (page) {
        params["page"] = page - 1;
      }

      if (pageSize) {
        params["size"] = pageSize;
      }

      return params;
    },

    handleDisplayChange() {
      this.page = 1;

      const params = this.getRequestParams(
          this.page,
          this.pageSizes.selected,
      );

      MarketingDataService.getAppUninstalls(params)
          .then(response => {
            const { items, totalItems } = response.data;
            this.uninstalls = items;
            this.count = totalItems;
          })
          .catch(error => {
            window.console.error(error);
            this.$toast.error(this.$t("marketing.appUninstalls.errorNoResult"));
          });
    },

    handlePageChange(value) {
      this.page = value;
      this.processFilters();
    },

    handleDateChange() {
      let now = new this.$moment();
      switch(this.filters.dates.selected) {
        case "always":
          this.filters.fromDate = new this.$moment('2021-01-01').format('YYYY-MM-DD');
          this.filters.toDate = now.format('YYYY-MM-DD');
          break;
        case "week":
          this.filters.toDate = now.format('YYYY-MM-DD');
          this.filters.fromDate = now.subtract(1, 'week').startOf('day').format('YYYY-MM-DD');
          break;
        case "curMonth":
          this.filters.toDate = now.format('YYYY-MM-DD');
          this.filters.fromDate = now.startOf('month').format('YYYY-MM-DD');
          break;
        case "last30Day":
          this.filters.toDate = now.format('YYYY-MM-DD');
          this.filters.fromDate = now.subtract(30, 'day').startOf('day').format('YYYY-MM-DD');
          break;
        case "lastMonth":
          this.filters.fromDate = now.subtract(1, 'month').startOf('month').format('YYYY-MM-DD');
          this.filters.toDate = now.endOf('month').format('YYYY-MM-DD');
          break;
        case "last3Month":
          this.filters.toDate = now.format('YYYY-MM-DD');
          this.filters.fromDate = now.subtract(3, 'month').startOf('day').format('YYYY-MM-DD');
          break;
        case "curYear":
          this.filters.toDate = now.format('YYYY-MM-DD');
          this.filters.fromDate = now.startOf('year').format('YYYY-MM-DD');
          break;
        case "custom":
          this.filters.fromDate = null;
          this.filters.toDate = null;
          break;
      }
    },

    trunc(value) {
      if (!isEmpty(value)) {
        if (value.length > 70)
          return value.substring(0, 70) + "…";
        else
          return value;
      }
      else {
        return "";
      }
    },

    getFilters() {
      MarketingDataService.getAppUninstallsFilters()
          .then(response => {
            response.data.filters.sdks.forEach(sdk => {
              this.filters.sdks.options.push(sdk);
            });

            response.data.filters.devices.forEach(device => {
              this.filters.devices.options.push(device);
            });

            response.data.filters.appVersions.forEach(version => {
              this.filters.appVersions.options.push(version);
            });

            response.data.filters.countries.forEach(country => {
              this.filters.countries.options.push(country);
            });
          })
          .catch(error => {
            window.console.error(error);
            this.$toast.error(this.$t("marketing.appUninstalls.getFilters"));
          });
    },

    processFilters() {
      if (!this.isLoading)
        this.isLoading = true;

      const params = this.getRequestParams(
          this.page,
          this.pageSizes.selected,
      );

      if (this.filters.dates.selected === 'custom' && this.filters.dates.dateRange !== null) {
        this.filters.fromDate = this.$moment(this.filters.dates.dateRange[0]).format("YYYY-MM-DD 00:00:00");
        this.filters.toDate = this.$moment(this.filters.dates.dateRange[1]).format("YYYY-MM-DD 23:59:59");
      }
      else if (this.filters.fromDate === null)
        this.handleDateChange();

      if (this.filters.toDate !== null)
        params['toDate'] = this.filters.toDate;

      if (this.filters.fromDate !== null)
        params['fromDate'] = this.filters.fromDate;

      params['sdks'] = this.filters.sdks.selected;
      params['devices'] = this.filters.devices.selected;
      params['origin'] = this.filters.origins.selected;
      params['gender'] = this.filters.genders.selected;
      params['country'] = this.filters.countries.selected;
      params['appVersion'] = this.filters.appVersions.selected;

      MarketingDataService.getAppUninstalls(params)
          .then(async response => {
            const { items, totalItems } = response.data;
            this.uninstalls = items;
            this.count = totalItems;
            let that = this;
            setTimeout(() => that.getMediaThumb(), 1000);
          })
          .catch(error => {
            window.console.error(error);
            this.$toast.error(this.$t("marketing.appUninstalls.errorNoResult"));
          });

      MarketingDataService.getAppUninstallsStats(params)
          .then(response => {
            this.stats.origins.series = response.data.origins.series;
            this.stats.origins.chartOptions = {...this.stats.origins.chartOptions, ...{
                labels: response.data.origins.labels
              }};

            this.stats.sdks.series = response.data.sdks.series;
            this.stats.sdks.chartOptions = {...this.stats.sdks.chartOptions, ...{
                labels: response.data.sdks.labels
              }};

            this.stats.devices.series = response.data.devices.series;
            this.stats.devices.chartOptions = {...this.stats.devices.chartOptions, ...{
                labels: response.data.devices.labels
              }};

            this.stats.appVersions.series = response.data.appVersions.series;
            this.stats.appVersions.chartOptions = {...this.stats.appVersions.chartOptions, ...{
                labels: response.data.appVersions.labels
              }};

            this.$refs.appUninstallsHistoryGraph.updateSeries([{
              name: "Users Registered Uninstalls",
              type: "column",
              data: response.data.historyGraph.users
            }, {
              name: "No Account Uninstalls",
              type: "column",
              data: response.data.historyGraph.anonymous
            }]);

            this.$refs.appUninstallsHistoryDelayGraph.updateSeries([{
              name: "Media Delay",
              type: "line",
              data: response.data.historyGraph.delay
            }]);


            this.total.uninstalls = response.data.total.uninstalls;
            this.total.users = response.data.total.users;
            this.total.anonymous = response.data.total.anonymous;
            this.total.delay = response.data.total.delay;
            this.isLoading = false;
          })
          .catch(error => {
            window.console.error(error);
            this.isLoading = false;
            this.$toast.error(this.$t("marketing.appUninstalls.errorNoResult"));
          })
    },

    getGenderImg(sex) {
      return require('@/assets/images/'+(sex === 1?'man':'woman')+'.png')
    },


    showContextMenu(event, user) {
      if (!isEmpty(user.userId))
        this.$refs.appUninstallsContextMenu.showMenu(event, user)
    },

    processContextMenu(event) {
      const { item, option } = event;
      switch (option.value) {
        case "show":
          this.showUser(item.userId);
          break;
      }
    },

    /* User profile */
    openUserPane() {
      if (!this.isUserPaneDisplayed)
        this.isUserPaneDisplayed = true;
    },

    closeUserPane() {
      this.userTabsActive = '';
      this.isUserPaneDisplayed = false;
    },

    async showUser(userId) {
      const isUserAlreadyDisplayed = this.userTabs.findIndex(x => x.userId === userId);
      let forceShow = false;
      if (isUserAlreadyDisplayed === -1) {
        try {
          const result = await UsersDataService.get(userId);
          if (typeof result.data === 'undefined')
            throw new Error('unable to find user '+userId);

          this.userTabs.push(UserUtils.normalize(result.data));
          forceShow = true;
        }
        catch (error) {
          window.console.error(error);
          this.$toast.error(this.$t("global_error"));
        }
      }

      this.openUserPane();

      if (forceShow || (!forceShow && this.userTabsActive !== userId)) {
        this.userTabsActive = '';
        setTimeout(() => { this.userTabsActive = userId; }, 100);
      }
    },

    showUserMedia(media, index) {
      this.userMedia.media = media;
      this.userMedia.index = index;
    },

    removeUserTab(userId) {
      const index = this.userTabs.findIndex(x => x.userId === userId);
      if (index > -1)
        this.userTabs.splice(index, 1);

      if (this.userTabs.length === 0)
        this.closeUserPane();
    }
  },

  data() {
    return {
      stats: {
        sdks: {
          series:[],
          chartOptions: {
            chart: {
              id: 'app-uninstalls-sdk',
              type: 'donut',
            },
            labels: [],
            dataLabels: {
              enabled: true
            },
            legend: {
              position: 'left'
            },
            noData: {
              text: 'Loading...'
            }
          },
        },
        devices: {
          series:[],
          chartOptions: {
            chart: {
              id: 'app-uninstalls-devices',
              type: 'donut',
            },
            dataLabels: {
              enabled: true
            },
            labels:[],
            noData: {
              text: 'Loading...'
            },
            legend: {
              position: 'left'
            },
          }
        },
        origins: {
          series:[],
          chartOptions: {
            chart: {
              id: 'app-uninstalls-origins',
              type: 'donut',
            },
            labels: [],
            dataLabels: {
              enabled: true
            },

            legend: {
              position: 'left'
            },
            noData: {
              text: 'Loading...'
            }
          },
        },
        appVersions: {
          series:[],
          chartOptions: {
            chart: {
              id: 'app-uninstalls-appversions',
              type: 'donut',
            },
            labels: [],
            dataLabels: {
              enabled: true
            },

            legend: {
              position: 'left'
            },
            noData: {
              text: 'Loading...'
            }
          },
        },
        historyGraph: {
          series:[],
          chartOptions: {
            chart: {
              id: 'app-uninstalls-history',
              stacked: true,
              type: 'bar',
              height: 350,
              zoom: {
                autoScaleYaxis: true
              },

              toolbar: {
                show: true,
                offsetX: 0,
                offsetY: 0,
                tools: {
                  download: false,
                  selection: true,
                  zoom: true,
                  zoomin: true,
                  zoomout: true,
                  pan: false,
                  reset: true
                }
              }
            },
            colors: ['#ef5744', '#666666'],
            dataLabels: {
              enabled: false
            },
            xaxis: {
              type: 'datetime',
              labels: {
                show: true,
                style: {
                  fontSize: 0
                },
                hideOverlappingLabels: true
              }
            },
            noData: {
              text: 'Loading...'
            }
          },
        },
        historyDelayGraph: {
          series:[],
          chartOptions: {
            chart: {
              id: 'app-uninstalls-delay-history',
              stacked: true,
              type: 'line',
              height: 350,
              zoom: {
                autoScaleYaxis: true
              },

              toolbar: {
                show: true,
                offsetX: 0,
                offsetY: 0,
                tools: {
                  download: false,
                  selection: true,
                  zoom: true,
                  zoomin: true,
                  zoomout: true,
                  pan: false,
                  reset: true
                }
              }
            },
            colors: ['#ef5744'],
            dataLabels: {
              enabled: false
            },
            tooltip: {
              shared: true,
              intersect: false
            },
            stroke: {
              width: 3,
              curve: 'smooth',
            },
            xaxis: {
              type: 'datetime',
              labels: {
                show: true,
                style: {
                  fontSize: 0
                },
                hideOverlappingLabels: true
              }
            },
            noData: {
              text: 'Loading...'
            }
          },
        }
      },
      total: {
        uninstall: 0,
        users: 0,
        anonymous: 0,
      },
      uninstalls: [],
      page: 1,
      count: 0,
      isLoading: true,
      title: this.$t("menuitems.marketing.uninstalls"),
      pageSizes: {
        options: ['20', '50', '100'],
        selected: '20'
      },
      filters: {
        fromDate: null,
        toDate: null,
        sdks: {
          selected: 'all',
          options: [{
            value: 'all', text: 'All SDKs'
          }]
        },
        origins: {
          selected: 'all',
          options: [
            {value: 'all', text: 'All Origins'},
            {value: 'U', text: 'Only Users'},
            {value: 'A', text: 'Only Anonymous'}
          ]
        },
        devices: {
          selected: 'all',
          options: [{
            value: 'all', text: 'All Devices'
          }]
        },
        appVersions: {
          selected: 'all',
          options: [{
            value: 'all', text: 'All App Versions'
          }]
        },
        countries: {
          selected: 'all',
          options: [{
            value: 'all', text: 'All Countries'
          }]
        },
        genders: {
          selected: 'all',
          options: [
              { value: 'all', text: 'All Genders' },
              { value: 1, text: 'Men' },
              { value: 2, text: 'Women' }
          ]
        },
        dates: {
          dateRange: null,
          selected: 'last30Day',
          options: [
              {value:'week', text:this.$t("dates.week")},
              {value:'curMonth', text:this.$t("dates.curMonth")},
              {value:'last30Day', text:this.$t("dates.last30Day")},
              {value:'lastMonth', text:this.$t("dates.lastMonth")},
              {value:'last3Month', text:this.$t("dates.last3Month")},
              {value:'curYear', text:this.$t("dates.curYear")},
              {value:'always', text:this.$t("dates.always")},
              {value:'custom', text:this.$t("dates.custom")}
          ]
        }
      },

      optionsContext: [
        {
          name: this.$t("show_user"),
          value: 'show'
        },
      ],

      /* User profile */
      isUserPaneDisplayed: false,
      userTabs:[],
      userTabsActive: '',
      userMedia: {
        media: [],
        index: -1
      },
    };
  },

  mounted() {
    this.getFilters();
    this.processFilters();
  }
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" />
    <div class="position-relative">
      <b-button
          class="position-fixed"
          style="top: 77px; right: 15px;z-index:150"
          v-show="!isUserPaneDisplayed && userTabs.length > 0"
          @click="openUserPane"
          variant="outline-primary">
        <i class="bx bxs-cog"></i> Show Panel
      </b-button>

      <!-- Filters -->
      <div class="card">
        <div class="card-body row">
          <b-form inline class="row gy-2 gx-3 align-items-center" id="appUninstallsFiltersForm" @submit.stop.prevent>

            <!-- dates -->
            <div class="col-sm-auto d-flex">
              <b-form-select
                  id="appUninstallsDatesFilter"
                  @change="handleDateChange"
                  v-model="filters.dates.selected"
                  class="form-select me-lg-1"
                  :options="filters.dates.options">
              </b-form-select>
              <date-picker
                  v-show="filters.dates.selected === 'custom'"
                  :lang="page.localePicker"
                  :placeholder="this.$t('choose_date_interval')"
                  type="date"
                  value-type="format"
                  show-week-number
                  v-model="filters.dates.dateRange"
                  class="me-lg-2"
                  range append-to-body ></date-picker>

            </div>

            <!-- SDKs -->
            <div class="col-sm-auto">
              <b-form-select
                  id="appUninstallsSdkFilter"
                  v-model="filters.sdks.selected"
                  class="form-select me-lg-1"
                  :options="filters.sdks.options">
              </b-form-select>
            </div>

            <!-- Devices -->
            <div class="col-sm-auto">
              <b-form-select
                  id="appUninstallsDevicesFilter"
                  v-model="filters.devices.selected"
                  class="form-select me-lg-1"
                  :options="filters.devices.options">
              </b-form-select>
            </div>

            <!-- Origin -->
            <div class="col-sm-auto">
              <b-form-select
                  id="appUninstallsOriginsFilter"
                  v-model="filters.origins.selected"
                  class="form-select me-lg-1"
                  :options="filters.origins.options">
              </b-form-select>
            </div>

            <!-- AppVersions -->
            <div class="col-sm-auto">
              <b-form-select
                  id="appUninstallsAppVersionsFilter"
                  v-model="filters.appVersions.selected"
                  class="form-select me-lg-1"
                  :options="filters.appVersions.options">
              </b-form-select>
            </div>

            <!-- Countries -->
            <div class="col-sm-auto">
              <b-form-select
                  id="appUninstallsCountriesFilter"
                  v-model="filters.countries.selected"
                  class="form-select me-lg-1"
                  :options="filters.countries.options">
              </b-form-select>
            </div>

            <!-- Genders -->
            <div class="col-sm-auto">
              <b-form-select
                  id="appUninstallsGendersFilter"
                  v-model="filters.genders.selected"
                  class="form-select me-lg-1"
                  :options="filters.genders.options">
              </b-form-select>
            </div>

            <div class="col-sm-auto">
              <b-button variant="primary" class="w-md" @click="processFilters">{{ $t("find") }}</b-button>
            </div>
          </b-form>
        </div>
      </div>

      <!-- Loader -->
      <div class="row d-flex justify-content-center">
        <vue-ellipse-progress
            v-show="isLoading"
            :loading="isLoading"
            :angle="-90"
            color="#50a5f1"
            emptyColor="#999"
            emptyColorFill="#f8f8fb"
            :size="100"
            :thickness="3"
            :emptyThickness="2"
            lineMode="out 2"
            animation="bounce 700 400"
            fontColor="#666"
            :half="false"
            class="mt-5 mb-5"
            fontSize="1rem">
        </vue-ellipse-progress>
      </div>

      <!-- Stats Plain -->
      <div class="row">
        <!-- appUninstalls -->
        <div class="col-lg-3">
          <div class="card mini-stats-wid">
            <div class="card-body">
              <div class="d-flex flex-wrap">
                <div class="me-3">
                  <p class="text-muted mb-2">App-Uninstalls</p>
                  <h5 class="mb-0">{{ total.uninstalls }}</h5>
                </div>

                <div class="avatar-sm ms-auto">
                  <div
                      class="avatar-title bg-info rounded-circle white font-size-20"
                  >
                    <i class="bx bx-download"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- registered users -->
        <div class="col-lg-3">
          <div class="card blog-stats-wid ">
            <div class="card-body">
              <div class="d-flex flex-wrap">
                <div class="me-3">
                  <p class="text-muted mb-2">Users Registered Uninstalls</p>
                  <h5 class="mb-0">{{ total.users }}</h5>
                </div>

                <div class="avatar-sm ms-auto">
                  <div
                      class="avatar-title bg-success text-white rounded-circle font-size-20"
                  >
                    <i class="bx bxs-folder-plus"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- anonymous -->
        <div class="col-lg-3">
          <div class="card blog-stats-wid">
            <div class="card-body">
              <div class="d-flex flex-wrap">
                <div class="me-3">
                  <p class="text-muted mb-2">No Accounts Uninstalls</p>
                  <h5 class="mb-0">{{ total.anonymous }}</h5>
                </div>

                <div class="avatar-sm ms-auto">
                  <div
                      class="avatar-title bg-pink rounded-circle text-white font-size-20"
                  >
                    <i class="bx bxs-right-arrow-square"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- delay -->
        <div class="col-lg-3">
          <div class="card blog-stats-wid">
            <div class="card-body">
              <div class="d-flex flex-wrap">
                <div class="me-3">
                  <p class="text-muted mb-2">Delay Median</p>
                  <h5 class="mb-0">{{ total.delay }} Days</h5>
                </div>

                <div class="avatar-sm ms-auto">
                  <div
                      class="avatar-title bg-dark rounded-circle text-white font-size-20"
                  >
                    <i class="bx bxs-right-arrow-square"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>

      <!-- Charts -->
      <div class="row">
        <div class="col-12 col-lg-6">

          <div class="card">
            <div class="card-body" id="cardChartDevices">
              <h5 class="card-title">Devices</h5>
              <apexchart
                  ref="appUninstallsDevicesChart"
                  height="250"
                  type="donut"
                  dir="ltr"
                  :series="stats.devices.series"
                  :options="stats.devices.chartOptions"
              ></apexchart>
            </div>
          </div>

        </div>

        <div class="col-12 col-lg-6">

          <div class="card">
            <div class="card-body" id="cardChartSDK">
              <h5 class="card-title">SDK</h5>
              <apexchart
                  ref="appUninstallsSDKChart"
                  type="donut"
                  height="250"
                  dir="ltr"
                  :series="stats.sdks.series"
                  :options="stats.sdks.chartOptions"
              ></apexchart>
            </div>
          </div>

        </div>

      </div>
      <div class="row">

        <div class="col-12 col-lg-6">

          <div class="card">
            <div class="card-body" id="cardChartOrigins">
              <h5 class="card-title">Origins</h5>
              <apexchart
                  ref="appUninstallsOriginsChart"
                  type="donut"
                  height="250"
                  dir="ltr"
                  :series="stats.origins.series"
                  :options="stats.origins.chartOptions"
              ></apexchart>
            </div>
          </div>

        </div>

        <div class="col-12 col-lg-6">

          <div class="card">
            <div class="card-body" id="cardChartOrigins">
              <h5 class="card-title">AppVersions</h5>
              <apexchart
                  ref="appUninstallsAppVersionsChart"
                  type="donut"
                  height="250"
                  dir="ltr"
                  :series="stats.appVersions.series"
                  :options="stats.appVersions.chartOptions"
              ></apexchart>
            </div>
          </div>

        </div>

      </div>

      <!-- Charts 2 -->
      <div class="row">

        <div class="col-12">

          <div class="card">
            <div class="card-body" id="cardChartHistory">
              <h5 class="card-title">Uninstalls History</h5>
              <apexchart
                  ref="appUninstallsHistoryGraph"
                  type="bar"
                  dir="ltr"
                  height="350"
                  :series="stats.historyGraph.series"
                  :options="stats.historyGraph.chartOptions"
              ></apexchart>

              <h5 class="card-title">Delay Median History (days)</h5>
              <apexchart
                  ref="appUninstallsHistoryDelayGraph"
                  type="bar"
                  dir="ltr"
                  height="350"
                  :series="stats.historyDelayGraph.series"
                  :options="stats.historyDelayGraph.chartOptions"
              ></apexchart>
            </div>
          </div>

        </div>

      </div>

      <!-- Top list tools -->
      <div class="row mb-3">
        <!-- Display settings -->
        <div class="col-lg-auto col-12">
          <b-select class="form-select d-inline w-auto m-1" v-model="pageSizes.selected" @change="handleDisplayChange">
            <option v-for="size in pageSizes.options" :key="size" :value="size">{{ size }} {{ $t('pageSize') }}</option>
          </b-select>
        </div>
        <!-- Pagination -->
        <div class="col-lg-auto col-12">
          <div class="m-1 pagination-rounded">
            <b-pagination
                v-model="page"
                :total-rows="count"
                :per-page="pageSizes.selected"
                first-number
                last-number
                @change="handlePageChange"
                aria-controls="appUninstalls-list"
            ></b-pagination>
            </div>
        </div>
      </div>

      <div class="row bg-white" v-if="!isLoading && uninstalls.length > 0">
        <!-- Result list -->
        <div class="table-responsive">
          <table
              id="appUninstalls-list"
              class="table project-list-table table-nowrap table-centered table-borderless align-middle">
            <thead>
            <tr>
              <th scope="col">{{ $t("appUninstalls.uninstallAt") }}</th>
              <th scope="col">{{ $t("appUninstalls.appVersion") }}</th>
              <th scope="col">{{ $t("appUninstalls.device") }}</th>
              <th scope="col">{{ $t("appUninstalls.user") }}</th>
              <th scope="col">{{ $t("appUninstalls.origin") }}</th>
              <th scope="col">{{ $t("appUninstalls.data") }}</th>
            </tr>
            </thead>
            <tbody>

            <tr v-for="uninstall in uninstalls" :key="uninstall.appUninstallId" @contextmenu.prevent.stop="showContextMenu($event, uninstall)">
              <td>
                <p class="text-muted font-size-12">
                  <b>{{ formatDateString(uninstall.uninstallAt, 'DD MMM YYYY HH:mm') }}</b><br>
                  <small>{{ formatDateString(uninstall.firstOpenAt, 'DD MMM YYYY HH:mm') }}</small><br>
                  <span class="badge bg-dark text-light">{{ uninstall.delay }} days</span>
                </p>
              </td>
              <td>
                <b>{{ uninstall.appSource }}</b>
                <span class="badge bg-success text-light">{{ uninstall.appVersion }}</span>
              </td>
              <td>
                <p class="text-muted font-size-12">
                  <small>{{ uninstall.deviceBrand }}</small>
                  <br><b>{{ uninstall.deviceMarketing }}</b> <i>({{ uninstall.deviceModel }})</i>
                  <br>SDK: {{ uninstall.deviceSdkVersion }}
                </p>
              </td>
              <td>
                <div class="media" v-if="!_isEmpty(uninstall.userId)">
                  <div class="avatar-xs">
                    <img
                        :id="`appUninstall-user-${uninstall.appUninstallId}`"
                        :src="require('@/assets/images/users/default-user.png')"
                        class="d-flex rounded-circle avatar-xs" />
                  </div>
                  <div class="media-body ms-1">
                    <h5 class="font-size-14 mb-0">
                      <span
                          :class="{
                          'text-primary': uninstall.sex === 1,
                          'text-danger': uninstall.sex === 2,
                          'text-dark': uninstall.sex === 0,
                        }"
                      >
                        {{ uninstall.name || '-' }}
                      </span> {{ getAge(uninstall.birth) }}</h5>
                    <small class="text-muted">#{{ uninstall.userId }}</small>
                  </div>
                </div>
              </td>
              <td>
                <b>{{ uninstall.origin }}</b>
              </td>
              <td>
                <p class="text-muted font-size-12">
                  <small>Sessions:</small> {{ uninstall.sessions}}
                  <br><small>Country: </small> {{ uninstall.geoCountry}}
                </p>
              </td>

            </tr>
            </tbody>
          </table>
        </div>
        <!-- END Result list -->
      </div>

      <!-- Result Empty -->
      <div class="row" v-if="!isLoading && uninstalls.length === 0">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title">Empty Result</h4>
              <p>No App Uninstalls were found for these filters. Try again.</p>
            </div>
          </div>
        </div>
      </div>

      <!-- bottom list tools -->
      <div class="row mb-3">
        <!-- Display settings -->
        <div class="col-lg-auto col-12">
          <b-select class="form-select d-inline w-auto m-1" v-model="pageSizes.selected" @change="handleDisplayChange">
            <option v-for="size in pageSizes.options" :key="size" :value="size">{{ size }} {{ $t('pageSize') }}</option>
          </b-select>
        </div>
        <!-- Pagination -->
        <div class="col-lg-auto col-12">
          <div class="m-1 pagination-rounded">
            <b-pagination
                v-model="page"
                :total-rows="count"
                :per-page="pageSizes.selected"
                first-number
                last-number
                @change="handlePageChange"
                aria-controls="appUninstalls-list"
            ></b-pagination>
          </div>
        </div>
      </div>

    </div>

    <b-sidebar id="sidebar-right" right v-model="isUserPaneDisplayed">
      <vue-tabs
          v-model="userTabsActive"
          active-tab-color="#213213"
          active-text-color="white">
        <v-tab v-for="userTab in userTabs" :key="userTab.userId" :title="userTab.userId" >
          <div slot="title">{{ userTab.name }} <i @click.stop="removeUserTab(userTab.userId)" class="bx bx-x-circle" ></i></div>
          <UserProfile
              :userId="null"
              :user="userTab"
              v-on:SHOW_MEDIA="showUserMedia">
          </UserProfile>
        </v-tab>
      </vue-tabs>
    </b-sidebar>

    <vue-simple-context-menu
        element-id="appUninstallsContextMenu"
        :options="optionsContext"
        ref="appUninstallsContextMenu"
        @option-clicked="processContextMenu"
    />

    <CoolLightBox
        :items="userMedia.media"
        :index="userMedia.index"
        :effect="'fade'"
        @close="userMedia.index = null">
    </CoolLightBox>

  </Layout>
</template>

<style>
  .gender-img {
    max-width: 30px;
    margin-right: 10px;
  }

  .cursor-pointer {
    cursor:pointer;
  }

  .b-sidebar-right {
    width:35%;
  }

  .b-sidebar-body {
    padding:16px;
  }

</style>
